const middleware = {}

middleware['auth-redirect-context'] = require('../middleware/auth-redirect-context.js')
middleware['auth-redirect-context'] = middleware['auth-redirect-context'].default || middleware['auth-redirect-context']

middleware['cart-restore'] = require('../middleware/cart-restore.js')
middleware['cart-restore'] = middleware['cart-restore'].default || middleware['cart-restore']

middleware['i18n-auth-redirect'] = require('../middleware/i18n-auth-redirect.js')
middleware['i18n-auth-redirect'] = middleware['i18n-auth-redirect'].default || middleware['i18n-auth-redirect']

middleware['order_payment_step'] = require('../middleware/order_payment_step.js')
middleware['order_payment_step'] = middleware['order_payment_step'].default || middleware['order_payment_step']

middleware['order_shipping_step'] = require('../middleware/order_shipping_step.js')
middleware['order_shipping_step'] = middleware['order_shipping_step'].default || middleware['order_shipping_step']

export default middleware
